import script from "./InboxDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InboxDialog.vue?vue&type=script&setup=true&lang=js"

import "./InboxDialog.vue?vue&type=style&index=0&id=4ba0c84e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba0c84e"]])

export default __exports__